import React, { useState, useEffect } from 'react';
import { Avatar, Box, Button, TextField, Typography, Paper } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import axios from 'axios';
import { obtenerLogoPublico } from '../utils/empresaConfig';
import { setFaviconFromLogo } from '../utils/favicon';

const Login = ({ setToken }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [logoBase64, setLogoBase64] = useState(null);

  useEffect(() => {
    const mensajeSesion = sessionStorage.getItem('login_mensaje');
    if (mensajeSesion) {
      setError(mensajeSesion);
      sessionStorage.removeItem('login_mensaje');
    }
  }, []);

  useEffect(() => {
    obtenerLogoPublico()
      .then(({ logo_base64 }) => {
        if (logo_base64) {
          setLogoBase64(logo_base64);
          setFaviconFromLogo(logo_base64);
        }
      })
      .catch(() => {
        // Sin logo disponible: se queda el ícono/candado por defecto.
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post('/api/auth/login', { username, password });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('usuario', JSON.stringify(res.data.usuario));
      setToken(res.data.token);
      window.location.href = '/dashboard';
    } catch (err) {
      if (err.response?.data?.fueraDeHorario) {
        setError(err.response.data.message);
      } else {
        setError('Usuario o contraseña incorrectos');
      }
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f5f5' }}>
      <Paper elevation={6} sx={{ p: 4, borderRadius: 4, minWidth: 350, maxWidth: 400, textAlign: 'center', position: 'relative' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }}>
          <Avatar
            src={logoBase64 ? `data:image/png;base64,${logoBase64}` : undefined}
            sx={{
              bgcolor: '#1976d2',
              width: 72,
              height: 72,
              mb: 1,
              '& .MuiAvatar-img': { objectFit: 'contain' }
            }}
          >
            <LockOutlinedIcon sx={{ fontSize: 40 }} />
          </Avatar>
          <Typography variant="h5" sx={{ fontWeight: 'bold' }}>Iniciar Sesión</Typography>
        </Box>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Usuario"
            variant="outlined"
            fullWidth
            margin="normal"
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
          />
          <TextField
            label="Contraseña"
            type="password"
            variant="outlined"
            fullWidth
            margin="normal"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          {error && <Typography color="error" sx={{ mt: 1 }}>{error}</Typography>}
          <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2, borderRadius: 2 }}>
            Entrar
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default Login;
